import script from "./GenerateDiagnosisCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateDiagnosisCreate.vue?vue&type=script&setup=true&lang=js"

import "./GenerateDiagnosisCreate.vue?vue&type=style&index=0&id=8ce3e576&lang=scss&scoped=true"
import "./GenerateDiagnosisCreate.vue?vue&type=style&index=1&id=8ce3e576&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Master-Leadership_Admin_Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ce3e576"]])

export default __exports__